<template>
  <v-container
    fluid
    class="d-flex justify-center align-center"
    pa-md-4
    pa-2
    style="min-height: 10vh; border-radius: 0"
  >
    <v-row class="d-flex justify-center">
      <v-col cols="12" sm="6" md="4" lg="10">
        <v-card rounded="0">
          <v-toolbar flat dense color="#005F95">
            <div>
              <!-- Small to Large Screens -->
              <h1
                class="NewApp-Toolbar"
                :style="{
                  fontSize: isSmall ? '11px' : isMedium ? '16px' : '20px',
                }"
              >
                DINERS CLUB {{ product }} ONLINE APPLICATION
              </h1>
            </div>
          </v-toolbar>

          <form ref="form" id="isFormGetQuoteValid" lazy-validation>
            <v-container fluid>
              <v-container fluid>
                <v-container fluid>
                  <v-row>
                    <v-col cols="12">
                      <div
                        style="text-align: center"
                        v-if="apptype === 'continueapp'"
                      >
                        <h3>Application Reference Number: {{ refNumber }}</h3>
                      </div>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12">
                      <p class="Contact-Information" style="text-align: left">
                        CONTACT INFORMATION
                      </p>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" sm="4">
                      <v-text-field
                        v-model="txtCellphone"
                        label="Cell Number"
                        :rules="[
                          validateField(
                            contactFieldRegex,
                            'Please enter 10 digit contact number'
                          ),
                        ]"
                        required
                        clearable
                        placeholder=""
                        counter
                        variant="underlined"
                        density="comfortable"
                        prepend-icon="mdi-phone"
                        maxlength="10"
                        type=""
                        color="#005F95"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="4">
                      <v-text-field
                        v-model="txtEmailaddress"
                        label="Email"
                        :rules="[
                          validateField(
                            emailAddressRegex,
                            'Invalid email address'
                          ),
                        ]"
                        @keyup="uppercase"
                        required
                        clearable
                        placeholder=""
                        maxlength="50"
                        variant="underlined"
                        density="comfortable"
                        prepend-icon="mdi-email"
                        counter
                        type="email"
                        color="#005F95"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <!--******************************************************* Title and Initials ******************************************** -->
                  <v-col cols="12">
                    <h1
                      style="text-align: left; color: #041e42"
                      class="Personal-Information"
                    >
                      PERSONAL INFORMATION:
                    </h1>
                  </v-col>

                  <v-row>
                    <v-col cols="12" sm="4">
                      <v-select
                        v-model="dropdowntitle"
                        :items="dropdown_title"
                        :rules="[(v) => !!v || 'Title is required']"
                        label="Title"
                        required
                        clearable
                        color="#005F95"
                        placeholder=""
                        variant="underlined"
                        density="comfortable"
                        prepend-icon="mdi-account"
                      ></v-select>
                    </v-col>

                    <v-col cols="12" sm="4">
                      <v-text-field
                        v-model="txtInitials"
                        label="Initials"
                        :rules="[
                          validateField(
                            textFieldRegex,
                            'Please enter text only'
                          ),
                        ]"
                        readonly
                        maxlength="10"
                        variant="underlined"
                        density="comfortable"
                        counter
                        @keyup="uppercase"
                        required
                        clearable
                        placeholder=""
                        type="text"
                        color="#005F95"
                        prepend-icon="mdi-account"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <!--******************************************************* First Name and Last Name ******************************************** -->
                  <v-row>
                    <v-col cols="12" sm="4">
                      <v-text-field
                        v-model="txtFirstname"
                        label="First Name"
                        :rules="[
                          validateField(
                            textFieldRegex,
                            'Please enter text only'
                          ),
                        ]"
                        @keyup="uppercasefirstname"
                        maxlength="50"
                        counter
                        required
                        clearable
                        placeholder=""
                        type="text"
                        color="#005F95"
                        variant="underlined"
                        density="comfortable"
                        prepend-icon="mdi-account"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="4">
                      <v-text-field
                        v-model="txtSurname"
                        label="Surname"
                        :rules="[
                          validateField(
                            textFieldRegex,
                            'Please enter text only'
                          ),
                        ]"
                        @keyup="uppercase"
                        maxlength="50"
                        counter
                        required
                        clearable
                        autocomplete="txtSurname"
                        placeholder=""
                        type="text"
                        color="#005F95"
                        variant="underlined"
                        density="comfortable"
                        prepend-icon="mdi-account"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <!--********************************************** ID Type, RSA ID and ID Number ******************************************** -->

                  <v-row>
                    <v-col cols="12" sm="4">
                      <v-select
                        v-model="dropdownIdentityType"
                        :items="dropdown_IdentityType"
                        :rules="[(v) => !!v || 'ID Type is required']"
                        label="Identity Type"
                        required
                        clearable
                        placeholder=""
                        type="text"
                        color="#005F95"
                        variant="underlined"
                        density="comfortable"
                        prepend-icon="mdi-account-details"
                        @update:modelValue="ClearPassportDetails"
                      ></v-select>
                    </v-col>

                    <v-col
                      cols="12"
                      sm="4"
                      v-if="dropdownIdentityType === 'RSA ID'"
                    >
                      <v-text-field
                        v-model="txtSaIdNumber"
                        label="Identity Number"
                        :rules="[validateSouthAfricanID]"
                        maxlength="13"
                        counter
                        @keyup="prepopulate()"
                        placeholder=""
                        mask="#############"
                        color="#005F95"
                        variant="underlined"
                        density="comfortable"
                        prepend-icon="mdi-account-details"
                      ></v-text-field>
                    </v-col>

                    <v-col
                      cols="12"
                      sm="4"
                      v-if="dropdownIdentityType === 'Passport'"
                    >
                      <v-text-field
                        v-model="txtPassportNumber"
                        @keyup="uppercase"
                        label="Passport Number"
                        :rules="[
                          validateField(
                            alphaNumericFieldRegex,
                            'Invalid Passport Number'
                          ),
                        ]"
                        type="aplha-numeric"
                        counter
                        maxlength="50"
                        required
                        clearable
                        color="#005F95"
                        variant="underlined"
                        density="comfortable"
                        prepend-icon="mdi-passport"
                      ></v-text-field>
                    </v-col>

                    <v-col
                      cols="12"
                      sm="4"
                      v-if="dropdownIdentityType === 'RSA ID'"
                    >
                      <v-menu
                        class="custom-prepend-icon"
                        v-model="menubirthdate"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                        color="#005F95"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="txtbirthdate"
                            label="Date Of Birth"
                            :rules="[(v) => !!v || 'Date of Birth is required']"
                            variant="underlined"
                            density="comfortable"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="on"
                          ></v-text-field>
                        </template>
                      </v-menu>
                      <p
                        v-if="agevalidation === true"
                        style="text-align: left; color: red"
                      >
                        {{ platinumBankingMessage }}
                      </p>
                    </v-col>

                    <v-col
                      cols="12"
                      sm="4"
                      v-if="dropdownIdentityType === 'Passport'"
                    >
                      <v-menu
                        v-model="menuDOBPassport"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                        color="#005F95"
                      >
                        <template v-slot:activator="{ props }">
                          <v-text-field
                            v-model="txtDOBPassport"
                            label="Date Of Birth"
                            :rules="[(v) => !!v || 'Date Of Birth is required']"
                            variant="underlined"
                            density="comfortable"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="props"
                            color="#005F95"
                            attach="body"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="pickerDOBPassport"
                          @update:modelValue="updateDateOfBirth"
                          color="#005F95"
                          :max="today"
                          :min="minDate"
                        ></v-date-picker>
                      </v-menu>
                      <p
                        v-if="agevalidation === true"
                        style="text-align: left; color: red"
                      >
                        {{ platinumBankingMessage }}
                      </p>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" sm="4">
                      <v-radio-group
                        v-model="radiosgender"
                        inline
                        :rules="[(v) => !!v || 'Gender is required!']"
                        required
                        row
                      >
                        <div class="d-flex align-center">
                          <span>Gender:</span>
                          <v-radio
                            label="Female"
                            value="F"
                            color="#005F95"
                          ></v-radio>
                          <v-radio
                            label="Male"
                            value="M"
                            color="#005F95"
                          ></v-radio>
                        </div>
                      </v-radio-group>
                    </v-col>

                    <v-col
                      cols="12"
                      sm="4"
                      v-if="dropdownIdentityType === 'Passport'"
                    >
                      <v-menu
                        v-model="menuPassExpDate"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                        color="#005F95"
                      >
                        <template v-slot:activator="{ props }">
                          <v-text-field
                            v-model="txtPassExpDate"
                            label="Passport Expiry Date"
                            :rules="[
                              (v) => !!v || 'Passport Expiry Date is required',
                            ]"
                            variant="underlined"
                            density="comfortable"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="props"
                            color="#005F95"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="pickerPassExpDate"
                          @update:modelValue="updatePassExpDate"
                          color="#005F95"
                          :min="new Date().toISOString().slice(0, 10)"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>

                  <!--******************************************************* Country Of Birth, Country Of Residence and Citizenship ******************************************** -->
                  <v-row>
                    <v-col cols="12" sm="4">
                      <v-select
                        v-model="dropdowncountryofbirth"
                        :items="dropdown_countryofbirth"
                        :rules="[(v) => !!v || 'Country of Birth is required']"
                        label="Country of Birth"
                        required
                        clearable
                        placeholder=""
                        type="text"
                        color="#005F95"
                        variant="underlined"
                        density="comfortable"
                        prepend-icon="mdi-city"
                      ></v-select>
                    </v-col>

                    <v-col cols="12" sm="4">
                      <v-select
                        v-model="dropdownCountryOfResidence"
                        :items="dropdown_CountryOfResidence"
                        label="Country of Residence"
                        :rules="[
                          (v) => !!v || 'Country of Residence is required',
                        ]"
                        variant="underlined"
                        density="comfortable"
                        prepend-icon="mdi-city"
                        required
                        clearable
                        placeholder=""
                        type="text"
                        color="#005F95"
                      ></v-select>
                    </v-col>

                    <v-col cols="12" sm="4">
                      <v-select
                        v-model="dropdowncountryofcitizenship"
                        :items="dropdown_countryofcitizenship"
                        label="Country of Citizenship"
                        :rules="[
                          (v) => !!v || 'Country of Citizenship is required',
                        ]"
                        variant="underlined"
                        density="comfortable"
                        prepend-icon="mdi-city"
                        required
                        clearable
                        placeholder=""
                        type="text"
                        color="#005F95"
                      ></v-select>
                    </v-col>
                  </v-row>

                  <!--******************************************************* Issuing Country, Country Of Residence and Citizenship ******************************************** -->
                  <v-row v-if="dropdownIdentityType === 'Passport'">
                    <v-col cols="12" sm="4">
                      <v-select
                        v-model="dropdownIssuingCountry"
                        :items="dropdown_IssuingCountry"
                        :rules="[(v) => !!v || 'Country Of Issue is required']"
                        label="Country Of Issue"
                        required
                        clearable
                        variant="underlined"
                        density="comfortable"
                        prepend-icon="mdi-city"
                        color="#005F95"
                        placeholder=""
                        type="text"
                        @change="ClearForeignDeclarationDetails()"
                      ></v-select>
                    </v-col>
                  </v-row>

                  <v-row v-if="dropdownIdentityType === 'Passport'">
                    <v-col cols="12">
                      <h1
                        style="text-align: left; color: #041e42"
                        class="Personal-Information"
                      >
                        RESIDENCY INFORMATION
                      </h1>
                    </v-col>
                  </v-row>

                  <v-row v-if="dropdownIdentityType === 'Passport'">
                    <v-col cols="12" sm="4">
                      <v-select
                        v-model="dropdownvisapermittype"
                        :items="dropdown_visapermittype"
                        label="Visa/Permit Type"
                        :rules="[(v) => !!v || 'Visa Type is required']"
                        required
                        clearable
                        placeholder=""
                        type="text"
                        color="#005F95"
                        variant="underlined"
                        density="comfortable"
                        prepend-icon="mdi-card-account-details"
                      ></v-select>
                    </v-col>

                    <v-col cols="12" sm="4">
                      <v-text-field
                        v-model="txtPermitNumber"
                        :rules="[
                          validateField(
                            numericFieldRegex,
                            'Please enter numbers only'
                          ),
                        ]"
                        @keyup="uppercase"
                        label="Visa/Permit Number"
                        maxlength="20"
                        counter
                        required
                        clearable
                        mask="NNNNNNNNNNNNNNNNNNNN"
                        placeholder=""
                        type="text"
                        color="#005F95"
                        variant="underlined"
                        density="comfortable"
                        prepend-icon="mdi-passport"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <!--***************************************************************** Visa Issue Date and Expery Date ********************************************************* -->
                  <v-row v-if="dropdownIdentityType === 'Passport'">
                    <v-col cols="12" sm="4">
                      <v-menu
                        v-model="menuVisaIssueDate"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                        color="#005F95"
                      >
                        <template v-slot:activator="{ props }">
                          <v-text-field
                            v-model="txtVisaIssueDate"
                            label="Visa/Permit Issue Date"
                            :rules="[
                              (v) =>
                                !!v || 'Visa/Permit Issue Date is required',
                            ]"
                            variant="underlined"
                            density="comfortable"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="props"
                            color="#005F95"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="pickerVisaIssueDate"
                          @update:modelValue="updateVisaIssueDate"
                          :max="today"
                          min="1950-01-01"
                          color="#005F95"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>

                    <v-col cols="12" sm="4">
                      <v-menu
                        v-model="menuVisaExpDate"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                        color="#005F95"
                      >
                        <template v-slot:activator="{ props }">
                          <v-text-field
                            v-model="txtVisaExpDate"
                            label="Visa/Permit Expiry Date"
                            :rules="[
                              (v) =>
                                !!v || 'Visa/Permit Expiry Date is required',
                            ]"
                            variant="underlined"
                            density="comfortable"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="props"
                            color="#005F95"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="pickerVisaExpDate"
                          :min="new Date().toISOString().slice(0, 10)"
                          color="#005F95"
                          @update:modelValue="updateVisaExpDate"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>

                  <!--************************************************************* Foreign National Declaration *************************************************************** -->
                  <v-row
                    v-if="
                      dropdownIdentityType === 'Passport' &&
                      dropdownIssuingCountry !== 'SOUTH AFRICA'
                    "
                  >
                    <v-col cols="12">
                      <h4
                        style="text-align: left; color: #041e42"
                        class="I-agree-and-confirm"
                      >
                        FOREIGN NATIONAL DECLARATION:
                      </h4>
                    </v-col>

                    <v-radio-group v-model="radioforeignassets" inline>
                      <v-radio label="Yes" value="Y" color="#005F95"></v-radio>
                      <v-radio label="No" value="N" color="#005F95"></v-radio>
                      <v-col cols="12" sm="8">
                        <p style="color: #041e42">
                          I declare that I am in possession of foreign assets
                          and I hereby declare that I will not place foreign
                          assets at the disposal of any third party normally
                          residing in South Africa.
                        </p>
                        <p
                          v-if="radioforeignassets === 'N'"
                          style="color: #d8000c"
                        >
                          You have to consent to a having foreign assets
                        </p>
                      </v-col>
                    </v-radio-group>

                    <v-radio-group v-model="radioemigration" inline>
                      <v-radio label="Yes" value="Y" color="#005F95"></v-radio>
                      <v-radio label="No" value="N" color="#005F95"></v-radio>
                      <v-col cols="12" sm="9">
                        <p style="text-align: left; color: #041e42">
                          I further declare that I have not previously emigrated
                          from the Republic.
                        </p>
                        <p
                          v-if="radioemigration === 'N'"
                          style="color: #d8000c; text-align: left"
                        >
                          You need to confirm that you have not migrated before
                        </p>
                      </v-col>
                    </v-radio-group>

                    <v-radio-group v-model="radiosimilarapp" inline>
                      <v-radio label="Yes" value="Y" color="#005F95"></v-radio>
                      <v-radio label="No" value="N" color="#005F95"></v-radio>

                      <v-col cols="12" sm="8">
                        <p style="color: #041e42">
                          I also declare that I have not applied for similar
                          facilities through another authorised dealer.
                        </p>
                        <p
                          v-if="radiosimilarapp === 'N'"
                          style="color: #d8000c"
                        >
                          You need to confirm that you have not applied for
                          similar services through another authorised dealer
                        </p>
                      </v-col>
                    </v-radio-group>
                    <br />
                  </v-row>

                  <!--**************************************** Total Monthly Income, Total Monthly Net Income and Fixed Monthly Expenses ************************************** -->

                  <v-row>
                    <v-col cols="12" sm="14">
                      <h1
                        style="text-align: left; color: #041e42"
                        class="Affordability"
                      >
                        AFFORDABILITY
                      </h1>
                    </v-col>

                    <!-- ************************--Platinum and Shariah Criteria--************************************** -->

                    <v-col
                      cols="12"
                      sm="4"
                      v-if="prodtype === 'platinum' || prodtype === 'shariah'"
                    >
                      <v-tooltip right>
                        <template v-slot:activator="{ props }">
                          <v-col cols="12" sm="">
                            <h3
                              style="text-align: left; color: #041e42"
                              class="Total-Gross-Monthly"
                            >
                              TOTAL GROSS MONTHLY INCOME
                              <v-icon
                                class="custom-help-icon"
                                color="#005F95"
                                v-bind="props"
                                style="cursor: pointer"
                                >mdi-help-circle-outline</v-icon
                              >
                            </h3>
                          </v-col>
                        </template>

                        <span>
                          All the types of permanent/ monthly income you get
                          such as salaries and wages before deductions<br />
                        </span>
                      </v-tooltip>
                      <v-text-field
                        v-model="txtTotalmonthlygrossincome"
                        label="Total Gross Monthly Income (ZAR)"
                        :rules="[
                          validateField(
                            numericFieldRegex,
                            'Please enter numbers only'
                          ),
                        ]"
                        placeholder="0"
                        prefix="R"
                        mask="###############"
                        required
                        clearable
                        type="text"
                        color="#005F95"
                        variant="underlined"
                        density="comfortable"
                        prepend-icon="mdi-cash-multiple"
                        @keyup="checklimit"
                      ></v-text-field>
                      <p
                        v-if="mincriteria === false"
                        style="text-align: left; color: #9f6000"
                      >
                        R41677 p/m required to apply
                      </p>
                    </v-col>

                    <!-- ************************--Beyond Criteria--************************************** -->

                    <v-col cols="12" sm="4" v-if="prodtype === 'beyond'">
                      <v-tooltip right>
                        <template v-slot:activator="{ props }">
                          <v-col col="12" sm="">
                            <h3
                              style="text-align: left; color: #041e42"
                              class="Total-Gross-Monthly"
                            >
                              TOTAL GROSS MONTHLY INCOME
                              <v-icon
                                class="custom-help-icon"
                                color="#005F95"
                                v-bind="props"
                                style="cursor: pointer"
                                >mdi-help-circle-outline</v-icon
                              >
                            </h3>
                          </v-col>
                        </template>

                        <span>
                          All the types of permanent/ monthly income you get
                          such as salaries and wages before deductions<br />
                        </span>
                      </v-tooltip>

                      <v-text-field
                        v-model="txtTotalmonthlygrossincome"
                        label="Total Gross Monthly Income (ZAR)"
                        :rules="[
                          validateField(
                            numericFieldRegex,
                            'Please enter numbers only'
                          ),
                        ]"
                        placeholder="0"
                        prefix="R"
                        mask="###############"
                        required
                        clearable
                        type="text"
                        color="#005F95"
                        variant="underlined"
                        density="comfortable"
                        prepend-icon="mdi-cash-multiple"
                        @keyup="checklimit"
                      ></v-text-field>
                      <p
                        v-if="mincriteria === false"
                        style="text-align: left; color: #9f6000"
                      >
                        R20833 p/m required to apply
                      </p>
                    </v-col>

                    <v-col cols="12" sm="4">
                      <v-tooltip right>
                        <template v-slot:activator="{ props }">
                          <v-col cols="12" sm="">
                            <h3
                              style="text-align: left; color: #041e42"
                              class="Total-Gross-Monthly"
                            >
                              TOTAL MONTHLY NET INCOME
                              <v-icon
                                class="custom-help-icon"
                                color="#005F95"
                                v-bind="props"
                                style="cursor: pointer"
                                >mdi-help-circle-outline</v-icon
                              >
                            </h3>
                          </v-col>
                        </template>

                        <span>
                          All the types of permanent/ monthly income you get
                          such as salaries and wages after deductions<br />
                        </span>
                      </v-tooltip>

                      <v-text-field
                        v-model="txtTotalmonthlynetincome"
                        label="Total Monthly Net Income (ZAR)"
                        :rules="[
                          validateField(
                            numericFieldRegex,
                            'Please enter numbers only'
                          ),
                        ]"
                        placeholder="0"
                        prefix="R"
                        mask="###############"
                        required
                        clearable
                        type="text"
                        color="#005F95"
                        variant="underlined"
                        density="comfortable"
                        prepend-icon="mdi-bank"
                        @keydown="checkAmnt()"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="4">
                      <v-tooltip right>
                        <template v-slot:activator="{ props }">
                          <v-col cols="12">
                            <h3
                              style="text-align: left; color: #041e42"
                              class="Total-Gross-Monthly"
                            >
                              TOTAL MONTHLY EXPENSES
                              <v-icon
                                class="custom-help-icon"
                                color="#005F95"
                                v-bind="props"
                                style="cursor: pointer"
                                >mdi-help-circle-outline</v-icon
                              >
                            </h3>
                          </v-col>
                        </template>

                        <span>
                          All types of monthly expenses such as payroll
                          deductions,<br />
                          housing, water and electricity clothing accounts,
                          and<br />
                          expenses related to debts, maintenance, alimony and
                          any other expenses.
                        </span>
                      </v-tooltip>

                      <v-text-field
                        v-model="txtTotalMonthlyExpenses"
                        label="Fixed Monthly Expenses"
                        :rules="[
                          validateField(
                            numericFieldRegex,
                            'Please enter numbers only'
                          ),
                        ]"
                        mask="###############"
                        prefix="R"
                        required
                        clearable
                        placeholder=""
                        color="#005F95"
                        variant="underlined"
                        density="comfortable"
                        prepend-icon="mdi-cash-multiple"
                      ></v-text-field>
                    </v-col> </v-row
                  ><br />
                  <br />

                  <!--********************************************************************* Declarations ********************************************************************* -->
                  <v-row>
                    <v-col cols="12">
                      <h1 style="text-align: left" class="Declarations">
                        DECLARATIONS
                      </h1>
                    </v-col>

                    <v-col cols="12">
                      <v-tooltip right>
                        <template v-slot:activator="{ props }">
                          <h2
                            style="text-align: left; color: #041e42"
                            class="Prominent-Influentia"
                          >
                            PROMINENT INFLUENTIAL PERSONS INFORMATION
                            <v-icon
                              class="custom-help-icon"
                              color="#005F95"
                              v-bind="props"
                              style="cursor: pointer"
                              >mdi-help-circle-outline</v-icon
                            >
                          </h2>
                        </template>
                        <span
                          >Prominent Influential Persons (PIPs) are people who
                          hold a prominent position in public office.
                        </span>
                      </v-tooltip>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" sm="6">
                      <p style="text-align: left; color: #041e42">
                        Are you a public official in a position of authority?
                      </p>
                    </v-col>

                    <v-col cols="12" sm="6">
                      <v-radio-group
                        v-model="radiopublicofficial"
                        inline
                        hide-details
                        row
                      >
                        <v-radio
                          label="Yes"
                          value="Y"
                          color="#005F95"
                          @change="radiorelationshipfunc()"
                        ></v-radio>
                        <v-radio label="No" value="N" color="#005F95"></v-radio>
                      </v-radio-group>
                    </v-col>

                    <v-col cols="12" sm="6">
                      <p style="text-align: left; color: #041e42">
                        Are you related to or associated to a public official in
                        a position of authority?
                      </p>
                    </v-col>

                    <v-col cols="12" sm="6">
                      <v-radio-group
                        v-model="radiorelationship"
                        inline
                        hide-details
                        row
                      >
                        <v-radio
                          label="Yes"
                          value="Y"
                          color="#005F95"
                        ></v-radio>
                        <v-radio label="No" value="N" color="#005F95"></v-radio>
                      </v-radio-group>
                    </v-col>
                  </v-row>

                  <v-row v-if="radiorelationship === 'Y'">
                    <v-col cols="12" sm="4">
                      <p style="text-align: left; color: #041e42">
                        What is the nature of the relationship or association?
                      </p>
                    </v-col>
                  </v-row>

                  <v-row
                    style="text-align: left"
                    v-if="radiorelationship === 'Y'"
                  >
                    <v-col cols="12" sm="4">
                      <v-select
                        v-model="dropdownrelationshiptype"
                        :items="dropdown_relationshiptype"
                        color="#005F95"
                        label="Relationship/Association"
                        required
                        clearable
                        placeholder=""
                        type="text"
                        variant="underlined"
                        density="comfortable"
                        prepend-icon="mdi-account-group"
                      ></v-select>
                    </v-col>
                  </v-row>

                  <v-col cols="12" sm="5" v-if="radiorelationship === 'Y'">
                    <p style="text-align: left; color: #041e42">
                      Please provide the fullname names and surname of the
                      relative or associate
                    </p>
                  </v-col>

                  <v-row
                    style="text-align: left"
                    v-if="radiorelationship === 'Y'"
                  >
                    <v-col cols="12" sm="4">
                      <v-text-field
                        v-model="txtAssociateName"
                        label="First Name"
                        :rules="[
                          validateField(
                            textFieldRegex,
                            'Please enter text only'
                          ),
                        ]"
                        @keyup="uppercase"
                        maxlength="50"
                        counter
                        required
                        clearable
                        autocomplete="txtAssociateName"
                        placeholder=""
                        type="text"
                        color="#005F95"
                        variant="underlined"
                        density="comfortable"
                        prepend-icon="mdi-account"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="4">
                      <v-text-field
                        v-model="txtAssociateSurname"
                        @keyup="uppercase()"
                        label="Surname"
                        :rules="[
                          validateField(
                            textFieldRegex,
                            'Please enter text only'
                          ),
                        ]"
                        placeholder=""
                        color="#005F95"
                        type="text"
                        variant="underlined"
                        density="comfortable"
                        prepend-icon="mdi-account"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" sm="7">
                      <h2
                        style="text-align: left; color: #041e42"
                        class="I-agree-and-confirm"
                      >
                        I AGREE AND CONFIRM THAT (REQUIRED):
                      </h2>
                    </v-col>

                    <v-col cols="12" sm="11">
                      <v-checkbox
                        v-model="check_NotInsolvent"
                        value="Yes"
                        color="#005F95"
                      >
                        <template v-slot:label>
                          <p
                            style="
                              text-align: left;
                              font-size: 14px;
                              font-family: 'GathamLight';
                              color: #041e42;
                            "
                          >
                            I am not insolvent, under debt review (current or
                            applied for), administration or sequestration.
                          </p>
                        </template>
                      </v-checkbox>

                      <p style="text-align: left; color: #041e42">
                        We understand that your personal information is
                        important to you. By using our products, you acknowledge
                        that your personal information will be processed by us
                        and third parties (if necessary) according to our
                        Privacy Statement, which is in line with all applicable
                        laws on protecting and processing personal information.
                      </p>

                      <p style="text-align: left; color: #041e42">
                        It is your responsibility to read and understand the
                        contents of the Privacy Statement which is available on
                        our website at
                        <a
                          target="_blank"
                          class="no-wrap"
                          href="https://www.standardbank.co.za/privacy"
                        >
                          www.standardbank.co.za/privacy
                        </a>
                        or you can ask us to email it to you.
                      </p>

                      <p style="text-align: left; color: #041e42">
                        We will maintain the confidentiality of your personal
                        information and we will implement security safeguards to
                        secure your personal information as set out in the
                        Privacy Statement. Our Privacy Statement includes what
                        personal information is; what information we process;
                        how we process your information; where we collect your
                        information; who we share your information with; your
                        rights as a data subject and the complaints contact
                        details of both Standard Bank and the Information
                        Regulator.
                      </p>

                      <v-checkbox
                        v-model="check_readandunderstood"
                        color="#005F95"
                        value="Yes"
                      >
                        <template #label>
                          <p class="checkboxLabel">
                            I have read and understood the above and accept the
                            terms of your Privacy statement.
                          </p>
                        </template>
                      </v-checkbox>
                    </v-col>

                    <v-col cols="12">
                      <h2
                        style="text-align: left; color: #041e42"
                        class="I-consent-to-Diners"
                      >
                        PLEASE ANSWER THE BELOW QUESTIONS REGARDING THE SHARING
                        OF YOUR DATA (REQUIRED):
                      </h2>
                    </v-col>

                    <v-col cols="12">
                      <p class="I-consent-to-Diners">
                        DATA SHARING WITHIN THE GROUP
                      </p>
                      <br />
                      <p style="text-align: lef; margin-bottom: -19px">
                        A member of
                        <a
                          target="_blank"
                          class="no-wrap"
                          href="https://www.standardbank.com/sbg/standard-bank-group/who-we-are/our-structure"
                          >the Group</a
                        >
                        may wish to inform you of exclusive offers and/or
                        services that may benefit you. Are you happy for us to
                        share your personal information within our Group for
                        this purpose?
                      </p>
                    </v-col>

                    <v-col cols="12" sm="5" style="margin-bottom: -19px">
                      <v-radio-group
                        v-model="radioSharewithgroup"
                        :rules="[
                          (v) => !!v || 'At least one field must be selected!',
                        ]"
                        inline
                        required
                      >
                        <v-radio
                          label="Yes"
                          value="Yes"
                          color="#005F95"
                        ></v-radio>
                        <v-radio
                          label="No"
                          value="No"
                          color="#005F95"
                        ></v-radio>
                      </v-radio-group>
                    </v-col>

                    <v-col cols="12">
                      <p class="I-consent-to-Diners">
                        DATA SHARING WITH THIRD PARTIES
                      </p>
                      <br />
                      <p style="text-align: left; margin-bottom: -19px">
                        We may partner with third parties outside of the Group
                        in order to bring you exclusive offers and/or services
                        that may benefit you. Are you happy for us to share your
                        personal information with these third parties for this
                        purpose?
                      </p>
                    </v-col>

                    <v-col cols="12" sm="5" style="margin-bottom: -19px">
                      <v-radio-group
                        v-model="radioThirdparty"
                        :rules="[
                          (v) => !!v || 'At least one field must be selected!',
                        ]"
                        inline
                        dense
                        required
                      >
                        <v-radio
                          label="Yes"
                          value="Yes"
                          color="#005F95"
                        ></v-radio>
                        <v-radio
                          label="No"
                          value="No"
                          color="#005F95"
                        ></v-radio>
                      </v-radio-group>
                    </v-col>

                    <v-col cols="12">
                      <p class="I-consent-to-Diners">
                        DATA SHARING ACROSS BORDERS WITHIN THE GROUP
                      </p>
                      <br />
                      <p style="text-align: left; margin-bottom: -19px">
                        A member of
                        <a
                          target="_blank"
                          class="no-wrap"
                          href="https://www.standardbank.com/sbg/standard-bank-group/who-we-are/our-structure"
                          >the Group</a
                        >
                        outside of this country may wish to inform you of
                        exclusive offers and/or services that may benefit you.
                        We will ensure that your personal information is given
                        the same protection as is required locally. Are you
                        happy for us to share your personal information across
                        borders within the Group for this purpose?
                      </p>
                    </v-col>

                    <v-col cols="12" sm="5" style="margin-bottom: -19px">
                      <v-radio-group
                        v-model="radioOthercountry"
                        :rules="[
                          (v) => !!v || 'At least one field must be selected!',
                        ]"
                        inline
                        required
                      >
                        <v-radio
                          label="Yes"
                          value="Yes"
                          color="#005F95"
                        ></v-radio>
                        <v-radio
                          label="No"
                          value="No"
                          color="#005F95"
                        ></v-radio>
                      </v-radio-group> </v-col
                  ></v-row>
                  <br />

                  <p style="text-align: left; color: #041e42">
                    <v-icon color="#005F95">mdi-lock</v-icon>Your information
                    will be managed securely and kept confidential. It will not
                    be shared with any third parties.
                  </p>
                  <br />

                  <v-btn
                    color="#005F95"
                    class="white--text"
                    style="border-radius: 0; width: 170px; height: 30px"
                    @click="custregister()"
                    :loading="isLoading"
                    :disabled="!isFormGetQuoteValid"
                  >
                    <span v-if="!isLoading">{{ Singlebtn }}</span>
                  </v-btn>
                </v-container>
              </v-container>
            </v-container>
          </form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
/* eslint-disable */
import { computed } from "vue";
import { useDisplay } from "vuetify/lib/framework.mjs";
import { ref, reactive, onBeforeMount, nextTick } from "vue";
import { useRouter } from "vue-router";
import axios from "axios"; // Import axios if not globally available
// import jwtAxios from "../auth/jwt"

const { smAndDown, mdAndUp, lgAndUp } = useDisplay();
const isSmall = smAndDown;
const isMedium = computed(() => mdAndUp.value && !lgAndUp.value);
const isLarge = lgAndUp;
const startnewapp = ref("");
const BeyondSelected = ref(false);
const product = ref("");
const prodtype = ref("");
const apptype = ref("");
const appStatus = ref(sessionStorage.getItem("appStatus")); // Accessing from sessionStorage
const refNumber = ref("");
const amntexceedErrMsg = ref("");
const isLoading = ref(false);
const partyId = ref(null);
const custid = ref("");
const gender = ref("");
const title = ref("");
const dob = ref("");
const idtype = ref("");
const province = ref("");

//Powercurve
const withdrawnCode = ref("");
const chargeoffDate = ref("");
const withdrawnDate = ref("");
const creditGranted = ref(0);

// Use Vue Router
const router = useRouter();
const valueCountryid = ref("076110");
const valueTitleid = ref("076010");
const valueEthnicgroupid = ref("019810");
const valueSpouseid = ref("074510");
const valueMaritalStatusid = ref("002810");
const valueVisaorPermitid = ref("070910");
const message = ref("");
const valID = ref("");
const menuVisible = ref("false");
const dateInput = ref("");

// Dropdowns Fields
const dropdowntitle = ref("");
const dropdown_title = ref([]);
const dropdownIdentityType = ref("");
const dropdown_IdentityType = ref(["RSA ID", "Passport"]);
const dropdowncountryofbirth = ref("");
const dropdown_countryofbirth = ref([]);
const dropdownCountryOfResidence = ref("");
const dropdown_CountryOfResidence = ref([]);
const dropdowncountryofcitizenship = ref("");
const dropdown_countryofcitizenship = ref([]);
const dropdownIssuingCountry = ref("");
const dropdown_IssuingCountry = ref([]);
const dropdownvisapermittype = ref("");
const dropdown_visapermittype = ref([]);
const dropdownrelationshiptype = ref("");
const dropdown_relationshiptype = ref([]);

// Radio Buttons
const radioforeignassets = ref("");
const radioemigration = ref("");
const radiosimilarapp = ref("");
const radiosgender = ref("");
const radioSharewithgroup = ref("");
const radioThirdparty = ref("");
const radioOthercountry = ref("");
const radiorelationship = ref("");
const radiopublicofficial = ref("");

// Text Fields
const txtInitials = ref("");
const txtFirstname = ref("");
const txtSurname = ref("");
const txtSaIdNumber = ref("");

const txtPassportNumber = ref("");
const txtCellphone = ref("");
const txtEmailaddress = ref("");
const txtPermitNumber = ref("");

const txtTotalmonthlygrossincome = ref("");
const txtTotalmonthlynetincome = ref("");
const txtTotalMonthlyExpenses = ref("");

const txtAssociateName = ref("");
const txtAssociateSurname = ref("");

const check_NotInsolvent = ref("");
const check_readandunderstood = ref("");

//RSA Date Pickers
const menubirthdate = ref("");
const txtbirthdate = ref("");

//Passport Date Picker
const menuDOBPassport = ref(false);
const txtDOBPassport = ref("");
const pickerDOBPassport = ref(null);

//Passport Expiry Date Picker
const menuPassExpDate = ref(false);
const txtPassExpDate = ref("");
const pickerPassExpDate = ref(null);

//Passport Visa Issue Date Picker
const menuVisaIssueDate = ref(false);
const txtVisaIssueDate = ref("");
const pickerVisaIssueDate = ref(null);

//Passport Visa Expiry Date Picker
const menuVisaExpDate = ref(false);
const txtVisaExpDate = ref("");
const pickerVisaExpDate = ref(null);

// Error Messages
const platinumBankingMessage = ref(
  "Applicant must be 18 and above to apply for a Diners Club Card"
);
const ageValidateMessage = ref("");
const Singlebtn = ref("GET QUOTE");

const agevalidation = ref(false);
const mincriteria = ref(true);

// Reusable validateField rule generator:
const validateField = (pattern, errorMessage) => {
  return (v) => {
    if (!v) return "This field is required";
    return pattern.test(v) || errorMessage;
  };
};

// Regex Patterns
const textFieldRegex = /^[A-Za-z\s]+$/;
const textFieldSpaceRegex = /^[ A-Za-z0-9_@./#&+-]*$/;
const textFieldHyphenRegex = /^[a-zA-Z\- s]+$/;
const alphaNumericFieldRegex = /^[a-zA-Z0-9\- s]+$/;
const numericFieldRegex = /^[0-9]*$/;
const contactFieldRegex = /^[0-9]{10}$/;
const emailAddressRegex = /^[\w-\.]+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}/;
const identityNumberRegex =
  /(((\d{2}((0[13578]|1[02])(0[1-9]|[12]\d|3[01])|(0[13456789]|1[012])(0[1-9]|[12]\d|30)|02(0[1-9]|1\d|2[0-8])))|([02468][048]|[13579][26])0229))(( |-)(\d{4})( |-)(\d{3})|(\d{7}))/;

//RSA ID Validator Function (Regex + DOB + Citizenship + Luhn)
function isValidSouthAfricanID(id) {
  if (!/^\d{13}$/.test(id)) return false;

  const year = parseInt(id.slice(0, 2), 10);
  const month = parseInt(id.slice(2, 4), 10);
  const day = parseInt(id.slice(4, 6), 10);
  const fullYear = year >= 0 && year <= 49 ? 2000 + year : 1900 + year;

  const date = new Date(`${fullYear}-${month}-${day}`);
  if (
    isNaN(date.getTime()) ||
    date.getFullYear() !== fullYear ||
    date.getMonth() + 1 !== month ||
    date.getDate() !== day
  )
    return false;

  const citizenship = parseInt(id.charAt(10), 10);
  if (citizenship !== 0 && citizenship !== 1) return false;

  let sum = 0;
  for (let i = 0; i < 12; i++) {
    let digit = parseInt(id.charAt(i), 10);
    if (i % 2 === 0) {
      sum += digit;
    } else {
      let doubled = digit * 2;
      sum += doubled > 9 ? doubled - 9 : doubled;
    }
  }

  const checkDigit = parseInt(id.charAt(12), 10);
  return (sum + checkDigit) % 10 === 0;
}

function validateSouthAfricanID(value) {
  if (!value) return true;
  return (
    isValidSouthAfricanID(value) ||
    "Please enter a valid South African ID number."
  );
}

//Form Field Validations

const isFormGetQuoteValid = computed(() => {
  const grossIncome = Number(txtTotalmonthlygrossincome.value);
  const identityType = dropdownIdentityType.value;
  const product = prodtype.value;
  const isPublicOfficial = radiopublicofficial.value;
  const isRelationship = radiorelationship.value;
  const relationshipType = dropdownrelationshiptype.value;
  const isPassportHolder = identityType === "Passport";
  const isIssuingNonSA = dropdownIssuingCountry.value !== "SOUTH AFRICA";

  // Common for both
  const meetsIncomeThreshold = (productType) => {
    if (productType === "beyond") return grossIncome >= 20833;
    if (productType === "platinum" || productType === "shariah")
      return grossIncome >= 41677;
    return true;
  };

  const isRelationshipValid = (isRelationship, relationshipType) => {
    if (isRelationship === "N") {
      return isRelationship.trim() !== "";
    } else if (isRelationship === "Y") {
      return (
        relationshipType.trim() !== "" &&
        txtAssociateName.value.trim() !== "" &&
        txtAssociateSurname.value.trim() !== ""
      );
    }
    return true;
  };

  // ✅ Validation for Passport Holders
  if (isPassportHolder) {
    const passportBaseValid = [
      txtCellphone.value.trim() !== "",
      txtEmailaddress.value.trim() !== "",
      dropdowntitle.value.trim() !== "",
      txtInitials.value.trim() !== "",
      txtFirstname.value.trim() !== "",
      txtSurname.value.trim() !== "",
      txtDOBPassport.value.trim() !== "",
      // txtbirthdate.value.trim() !== "",
      radiosgender.value.trim() !== "",
      agevalidation.value === false,
      txtTotalmonthlynetincome.value.trim() !== "",
      txtTotalMonthlyExpenses.value.trim() !== "",
      check_NotInsolvent.value,
      check_readandunderstood.value,
      dropdownCountryOfResidence.value.trim() !== "",
      dropdowncountryofbirth.value.trim() !== "",
      dropdowncountryofcitizenship.value.trim() !== "",
      radioSharewithgroup.value.trim() !== "",
      radioThirdparty.value.trim() !== "",
      radioOthercountry.value.trim() !== "",
      radiopublicofficial.value.trim() !== "",
      txtPassportNumber.value.trim() !== "",

      dropdownIssuingCountry.value.trim() !== "",
      dropdownvisapermittype.value.trim() !== "",
      txtPermitNumber.value.trim() !== "",
      txtVisaIssueDate.value.trim() !== "",
      txtVisaExpDate.value.trim() !== "",
      txtPassExpDate.value.trim() !== "",
    ];

    const nonSAFieldsValid = isIssuingNonSA
      ? [
          radioforeignassets.value === "Y",
          radioemigration.value === "Y",
          radiosimilarapp.value === "Y",
        ]
      : [];

    const allPassportFieldsValid = [
      ...passportBaseValid,
      ...nonSAFieldsValid,
    ].every(Boolean);

    if (!allPassportFieldsValid || !meetsIncomeThreshold(product)) return false;

    if (isPublicOfficial === "N") {
      return isRelationshipValid(isRelationship, relationshipType);
    }

    return true;
  }

  // ✅ Validation for SA ID Holders
  const saidBaseValid = [
    txtCellphone.value.trim() !== "",
    txtEmailaddress.value.trim() !== "",
    dropdowntitle.value.trim() !== "",
    txtInitials.value.trim() !== "",
    txtFirstname.value.trim() !== "",
    txtSurname.value.trim() !== "",
    txtSaIdNumber.value.trim() !== "",
    txtbirthdate.value.trim() !== "",
    radiosgender.value.trim() !== "",
    agevalidation.value === false,
    txtTotalmonthlynetincome.value.trim() !== "",
    txtTotalMonthlyExpenses.value.trim() !== "",
    check_NotInsolvent.value,
    check_readandunderstood.value,
    dropdownCountryOfResidence.value.trim() !== "",
    dropdowncountryofbirth.value.trim() !== "",
    dropdowncountryofcitizenship.value.trim() !== "",
    radioSharewithgroup.value.trim() !== "",
    radioThirdparty.value.trim() !== "",
    radioOthercountry.value.trim() !== "",
    radiopublicofficial.value.trim() !== "",
  ];

  if (!saidBaseValid.every(Boolean) || !meetsIncomeThreshold(product))
    return false;

  if (isPublicOfficial === "N") {
    return isRelationshipValid(isRelationship, relationshipType);
  }

  return true;
});

// Lifecycle hook
onBeforeMount(() => {
  // sessionStorage.clear();
  apptype.value = sessionStorage.getItem("apptype"); // Accessing from sessionStorage
  prodtype.value = sessionStorage.getItem("prodtype");
  appStatus.value = sessionStorage.getItem("appStatus");

  if (apptype.value === "newapp") {
    refNumber.value = sessionStorage.getItem("refNumber");
  } else if (apptype.value === "continueapp") {
    // sessionStorage.clear(refNumber.value);
    refNumber.value = sessionStorage.getItem("incompleteRef");
  }

  // Handle application status
  if (["Declined", "Approved", "Referred"].includes(appStatus.value)) {
    router.push("/");
    return;
  }

  // Determine product type
  switch (prodtype.value) {
    case "platinum":
      product.value = "CREDIT CARD";
      break;
    case "shariah":
      product.value = "SHARI'AH CARD";
      break;
    case "beyond":
      product.value = "BEYOND CARD";
      BeyondSelected.value = true;
      break;
  }

  // Handle new application type
  if (apptype.value === "newapp") {
    console.log("It's new app");
    // sessionStorage.clear();
    getGTSValueData();
  } else if (apptype.value === "continueapp" && refNumber.value) {
    // const appStatus = sessionStorage.getItem("appstatus");
    GetUserForReferenceNumber();

    if (
      ["Referred", "Approved", "Declined", "Pending"].includes(appStatus.value)
    ) {
      router.push("/ApplicationList");
    } else if (appStatus.value === "Incomplete") {
      console.log("App Status is: ", appStatus.value);
      getGTSValueData();
      getPersonalInfor();
      getFinancialsInfor();
      getDeclarations();
    }
  } else {
    router.push("/");
  }
});

// Methods / Functions
const uppercase = () => {
  if (txtEmailaddress.value.length > 50) {
    console.log("Too long");
  }
  txtEmailaddress.value = txtEmailaddress.value.toUpperCase();
  txtInitials.value = txtInitials.value.toUpperCase();
  // txtFirstname.value = txtFirstname.value.toUpperCase();
  txtSurname.value = txtSurname.value.toUpperCase();
  txtPassportNumber.value = txtPassportNumber.value.toUpperCase();
  txtAssociateName.value = txtAssociateName.value.toUpperCase();
  txtAssociateSurname.value = txtAssociateSurname.value.toUpperCase();
};

const uppercasefirstname = () => {
  txtFirstname.value = txtFirstname.value.toUpperCase();
  getInitials();
};
const getInitials = () => {
  txtInitials.value = txtFirstname.value
    .split(" ")
    .map((n) => n[0])
    .join("");
};

const ClearPassportDetails = (selectedType) => {
  if (selectedType === "Passport") {
    txtSaIdNumber.value = "";
    txtbirthdate.value = "";
    radiosgender.value = "";
    Singlebtn.value = "CONTINUE";
    dropdowncountryofcitizenship.value = "";
    dropdownCountryOfResidence.value = "";
    dropdowncountryofbirth.value = "";
    console.log("It is Passport");
  } else if (selectedType === "RSA ID") {
    console.log("It is RSA ID");
    Singlebtn.value = "GET QUOTE";
    txtPassportNumber.value = "";
    dropdownIssuingCountry.value = "";
    dropdowncountryofcitizenship.value = "";
    dropdownCountryOfResidence.value = "";
    dropdowncountryofbirth.value = "";
    dropdownvisapermittype.value = "";
    txtDOBPassport.value = "";
    txtPermitNumber.value = "";
    txtVisaIssueDate.value = "";
    txtPassExpDate.value = "";
    txtVisaExpDate.value = "";
    radioforeignassets.value = "";
    radioemigration.value = "";
    radiosimilarapp.value = "";
    radiosgender.value = "";
  }
};

const prepopulate = () => {
  var year = txtSaIdNumber.value.substring(0, 2);
  var month = txtSaIdNumber.value.substring(2, 4);
  var day = txtSaIdNumber.value.substring(4, 6);

  var currentYear = new Date().getFullYear() % 100;
  var prefix = "19";
  if (+year < currentYear) {
    prefix = "20";
  }
  var dob = prefix + year + "-" + month + "-" + day;
  getAge(dob);
  txtbirthdate.value = dob;

  var gender = parseInt(txtSaIdNumber.value.substring(6, 7), 10);

  if (gender < 5) {
    radiosgender.value = "F";
  } else {
    radiosgender.value = "M";
  }
};

// Define the maximum selectable date (e.g., today's date)
const maxDate = ref(new Date().toISOString().split("T")[0]); // Format as YYYY-MM-DD
const today = new Date().toISOString().split("T")[0];
const minDate = ref("1950-01-01");

// const updateDateOfBirth = (newDate) => {
//   nextTick(() => {
//     pickerDOBPassport.value = new Date(newDate);
//     txtDOBPassport.value = formatDate(pickerDOBPassport.value); // Format the date
//     menuDOBPassport.value = false; // Close the menu after selecting a date
//   });
// };
const updatePassExpDate = (newDate) => {
  nextTick(() => {
    pickerPassExpDate.value = new Date(newDate);
    txtPassExpDate.value = formatDate(pickerPassExpDate.value); // Format the date
    menuPassExpDate.value = false; // Close the menu after selecting a date
  });
};

const updateVisaIssueDate = (newDate) => {
  nextTick(() => {
    pickerVisaIssueDate.value = new Date(newDate);
    txtVisaIssueDate.value = formatDate(pickerVisaIssueDate.value); // Format the date
    menuVisaIssueDate.value = false; // Close the menu after selecting a date
  });
};

const updateVisaExpDate = (newDate) => {
  nextTick(() => {
    pickerVisaExpDate.value = new Date(newDate);
    txtVisaExpDate.value = formatDate(pickerVisaExpDate.value); // Format the date
    menuVisaExpDate.value = false; // Close the menu after selecting a date
  });
};

// Helper function to format date as YYYY-MM-DD
const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const formatPassDOBDate = (date) => {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = (d.getMonth() + 1).toString().padStart(2, "0");
  const day = d.getDate().toString().padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const updateDateOfBirth = (newDate) => {
  nextTick(() => {
    pickerDOBPassport.value = new Date(newDate);
    txtDOBPassport.value = formatPassDOBDate(pickerDOBPassport.value); // Format the date
    menuDOBPassport.value = false; // Close the menu after selecting a date
    validatePassportDOB(pickerDOBPassport.value);
  });
};

const validatePassportDOB = (dob) => {
  const today = new Date();
  const birthDate = new Date(dob);
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  const d = today.getDate() - birthDate.getDate();

  if (m < 0 || (m === 0 && d < 0)) {
    age--;
  }

  if (age < 18 || age > 99) {
    ageValidateMessage.value = platinumBankingMessage.value;
    agevalidation.value = true;
  } else {
    agevalidation.value = false;
  }
};

const getAge = (DOB) => {
  agevalidation.value = false;
  var today = new Date();
  var birthDate = new Date(DOB);
  var age = today.getFullYear() - birthDate.getFullYear();
  var m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age = age - 1;
  }
  if (DOB.length > 8) {
    if (age < 18) {
      ageValidateMessage.value = platinumBankingMessage.value;
      agevalidation.value = true;
    }
  }
};

const savePassExpDate = () => {
  txtPassExpDate.value = pickerPassExpDate.value;
  menuPassExpDate.value = false;
};

const radiorelationshipfunc = () => {
  radiorelationship.value = "";
  dropdownrelationshiptype.value = "";
  txtAssociateName.value = "";
  txtAssociateSurname.value = "";
};

const checklimit = () => {
  if (prodtype.value === "platinum" || prodtype.value === "shariah") {
    if (txtTotalmonthlygrossincome.value < 41677) {
      mincriteria.value = false;
    } else {
      mincriteria.value = true;
    }
  } else {
    if (txtTotalmonthlygrossincome.value < 20833) {
      mincriteria.value = false;
    } else {
      mincriteria.value = true;
    }
  }
};

const checkAmnt = () => {
  if ("Credit" === "Credit") {
    if (txtTotalmonthlygrossincome.value >= 41677) {
      amntexceedErrMsg.value = " ";
    } else if (txtTotalmonthlygrossincome.value <= 0) {
      amntexceedErrMsg.value = " ";
    } else {
      amntexceedErrMsg.value =
        "Total Gross Monthly Income should be equal or more than R41666.67";
    }
  }
};

//  ###################################################....Axios Back End Call Functions.....###################################################

const getGTSValues = (ValueListID) => {
  if (valueTitleid.value === null) {
    console.log("No value list ID");
    // isLoading.value = false;
  } else {
    axios
      .post("/getGTSValueList", { _SEQ_P: ValueListID })
      .then((response) => {
        const valArr = response.data.data._VALARR.filter(
          (value) => value !== ""
        );
        if (valArr[0] === "ADV") {
          dropdown_title.value = valArr;
        } else if (valArr[0] === "SOUTH AFRICA") {
          dropdown_IssuingCountry.value = valArr;
          // dropdown_nationality.value = valArr;
          dropdown_CountryOfResidence.value = valArr;
          dropdown_countryofbirth.value = valArr;
          dropdown_countryofcitizenship.value = valArr;
        } else if (valArr[0] === "Study Visa") {
          dropdown_visapermittype.value = valArr;
        } else if (valArr[0] === "SPOUSE/PARTNER") {
          dropdown_relationshiptype.value = valArr;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
};

const getGTSValueData = () => {
  getGTSValues(valueTitleid.value);
  getGTSValues(valueEthnicgroupid.value);
  getGTSValues(valueCountryid.value);
  getGTSValues(valueVisaorPermitid.value);
  getGTSValues(valueSpouseid.value);
  getGTSValues(valueMaritalStatusid.value);
};

//***********************************************Function to generate customer reference number*******************************************

const getRefNumber = async () => {
  isLoading.value = true;
  try {
    const response = await axios.post("/getRefNumber", {});
    if (response.data.data._RESPONSE === "SUCCESS") {
      if (response.data.data._REFNUMBER !== "") {
        sessionStorage.setItem("refNumber", response.data.data._REFNUMBER);
        refNumber.value = sessionStorage.getItem("refNumber");
        console.log(refNumber.value);
        updatePersonalInfor();
      }
    } else {
      console.log(
        "There Was An Issue While Generating Customer Reference Number: ",
        response
      );

      isLoading.value = false;
      router.push("/TechnicalError");
    }
  } catch (error) {
    console.error(error);
    isLoading.value = false;
    router.push("/TechnicalError");
  }
};

//***********************************************Function to Retrieve Customer Reference Number*******************************************

const GetUserForReferenceNumber = () => {
  axios
    .post("/GetUserForReferenceNumber", {
      _REFNUMBER: refNumber.value,
    })
    .then((response) => {
      if (response.data.data._USERID !== null) {
        // Handle the case where _USERID is not null
        console.log(response.data.data._USERID);
        // sessionStorage.setItem("userId", response.data.data._USERID)
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

// ********************************************Function to capture customer personal information******************************************

const updatePersonalInfor = async () => {
  if (apptype.value === "continueapp") {
    isLoading.value = true;
  }

  if (refNumber.value == null) {
    console.log("Customer Authentication Failed");
  } else {
    let txtDOB = "";
    let txtpassExpDate = "";

    if (dropdownIdentityType.value === "Passport") {
      txtDOB = new Date(txtDOBPassport.value)
        .toISOString()
        .slice(0, 10)
        .replace(/-/g, "");
      txtpassExpDate = new Date(txtPassExpDate.value)
        .toISOString()
        .slice(0, 10)
        .replace(/-/g, "");
    } else {
      txtDOB = new Date(txtbirthdate.value)
        .toISOString()
        .slice(0, 10)
        .replace(/-/g, "");
    }

    try {
      const response = await axios.post("/register", {
        _REFNUMBER: refNumber.value,
        _TELEPHONE: txtCellphone.value,
        _EMAIL: txtEmailaddress.value,
        _TITLE: dropdowntitle.value,
        _INITIALS: txtInitials.value,
        _FIRSTNAME: txtFirstname.value,
        _SURNAME: txtSurname.value,
        _IDTYPE: dropdownIdentityType.value,
        _ISSCOUNTRY: dropdownIssuingCountry.value,
        _IDNUMBER: txtSaIdNumber.value,
        _DATEOFBIRTH: txtDOB,
        _PASSPORT: txtPassportNumber.value,
        _GENDER: radiosgender.value,
        // _NATIONALITY: dropdownnationality.value,
        _PASSPORTEXP: txtpassExpDate,
        _COUNTRYRES: dropdownCountryOfResidence.value,
        _COUNTRYCIT: dropdowncountryofcitizenship.value,
        _COUNTRYBTH: dropdowncountryofbirth.value,
        _PRODUCT: prodtype.value,
      });

      const authToken =
        response.headers["authorization"] || response.headers["Authorization"];
      if (authToken) {
        sessionStorage.setItem("authToken", authToken); // Store the token in local storage
      }

      if (response.status !== 200) {
        console.log(response);
        isLoading.value = false;
        router.push("/TechnicalError");
      } else {
        if (
          response.data.data._RESPONSE === "UPDATED" ||
          response.data.data._RESPONSE === "ADDED"
        ) {
          sessionStorage.setItem("IDType", dropdownIdentityType.value);
          sessionStorage.setItem("SAID", txtSaIdNumber.value);
          sessionStorage.setItem("Passport", txtPassportNumber.value);
          sessionStorage.setItem("DateofBirth", txtDOB);
          sessionStorage.setItem("userid", txtEmailaddress.value);

          if (dropdownIdentityType.value === "Passport") {
            // refreshLocalStorageValues()
            GetUserForReferenceNumber();
            updateResidencyInfor();
          } else {
            // refreshLocalStorageValues()
            GetUserForReferenceNumber();
            updateFinancialsInfor();
          }
        }
      }
    } catch (error) {
      console.error(error);
      isLoading.value = false;
      router.push("/TechnicalError");
    }
  }
};

// **************************************Function to Call The Generate Ref Number and Personal Info****************************************

const custregister = () => {
  // const refNumber = sessionStorage.getItem('refNumber');

  if (refNumber.value === null) {
    getRefNumber(); // Call to getRefNumber function if refNumber is null
  } else if (refNumber.value !== null) {
    updatePersonalInfor(); // Call to updatePersonalInfor function if refNumber exists
  } else {
    console.log("Unauthorized User");
  }
};

// ********************************************Function to capture customer Residency Information******************************************
// Helper function to format dates
const formatDateYYYYMMDD = (date) => {
  return date
    ? new Date(date).toISOString().split("T")[0].replace(/-/g, "")
    : "";
};

// Method for updating residency information
const updateResidencyInfor = async () => {
  const token = sessionStorage.getItem("authToken");

  if (!refNumber.value && !token) {
    console.log("Customer Authentication Failed");
    return;
  } else {
    try {
      const response = await axios.post(
        "/updateResidencyInfor",
        {
          _REFNUMBER: refNumber.value,
          _VISATYPE: dropdownvisapermittype.value,
          _VISANUM: txtPermitNumber.value,
          _VISAISSUED: formatDateYYYYMMDD(txtVisaIssueDate.value),
          _VISAEXPIRES: formatDateYYYYMMDD(txtVisaExpDate.value),
          _FOREIGNASSET: radioforeignassets.value,
          _PREVEMIGRATE: radioemigration.value,
          _SIMFACILITY: radiosimilarapp.value,
        },
        {
          headers: {
            Authorization: token,
          },
        }
      );

      if (response.status !== 200) {
        isLoading.value = false;
        router.push("/TechnicalError");
      } else {
        if (
          response.data.data._RESPONSE === "UPDATED" ||
          response.data.data._RESPONSE === "ADDED"
        ) {
          if (refNumber.value) {
            GetUserForReferenceNumber(); // Make sure this function is defined
            updateFinancialsInfor(); // Ensure this function is defined or imported
          }
        } else {
          isLoading.value = false;
          router.push("/TechnicalError");
        }
      }
    } catch (error) {
      console.log(error);
      isLoading.value = false;
    }
  }
};

// ********************************************Function to capture customer Affordabilty Information****************************************

const updateFinancialsInfor = async () => {
  // const refNumber = refNumber.value;
  const token = sessionStorage.getItem("authToken");

  if (!refNumber.value && !token) {
    console.log("Customer Authentication Failed");
    return;
  } else {
    try {
      const response = await axios.post(
        "/updateFinancialsInfor",
        {
          _REFNUMBER: refNumber.value,
          _GROSSINCOME: parseInt(txtTotalmonthlygrossincome.value),
          _NETTINCOME: parseInt(txtTotalmonthlynetincome.value),
          _MONTHLYEXP: parseInt(txtTotalMonthlyExpenses.value),
        },
        {
          headers: {
            Authorization: token,
          },
        }
      );

      if (response.status !== 200) {
        isLoading.value = false;
        router.push("/TechnicalError");
      } else if (
        response.data.data._RESPONSE === "UPDATED" ||
        response.data.data._RESPONSE === "ADDED"
      ) {
        // Call other methods like GetUserForReferenceNumber & updateDeclarations
        GetUserForReferenceNumber();
        updateDeclarations();
      } else {
        isLoading.value = false;
        router.push("/TechnicalError");
      }
    } catch (error) {
      console.log(error);
      isLoading.value = false;
      router.push("/TechnicalError");
    }
  }
};

//*********************************************Function to Check Existing Card With Diners ************************************************

const checkExistingCard = async () => {
  const token = sessionStorage.getItem("authToken");

  if (!refNumber.value && !token) {
    console.log("Customer Authentication Failed");
    // isLoading.value = false;
    return;
  } else {
    try {
      const response = await axios.post(
        "/checkExistingCard",
        {
          REFNUMBER: refNumber.value,
          IDTYPE: dropdownIdentityType.value,
          IDNUMBER: txtSaIdNumber.value,
          PASSPORT: txtPassportNumber.value,
        },
        {
          headers: {
            Authorization: token,
          },
        }
      );

      if (response.status !== 200) {
        isLoading.value = false;
        router.push("/TechnicalError");
      } else {
        if (response.data.MATCHED === "Match Found") {
          sessionStorage.setItem("withdrawnCode", response.data.WITHDRAWNCODE);
          withdrawnCode.value = sessionStorage.getItem("withdrawnCode");
          sessionStorage.setItem("withdrawnDate", response.data.WITHDRAWNDATE);
          withdrawnDate.value = sessionStorage.getItem("withdrawnDate");
          sessionStorage.setItem("chargeoffDate", response.data.CHARGEOFFDATE);
          chargeoffDate.value = sessionStorage.getItem("chargeoffDate");

          FindCustBP()
          
        } else if (response.data.MATCHED === "No Match Found") {

          FindCustBP()
          
        } else {
          isLoading.value = false;
          router.push("/TechnicalError");
        }
      }
    } catch (error) {
      console.log(error);
      isLoading.value = false;
      router.push("/TechnicalError");
    }
  }
};

// ********************************************Function to capture customer Declaration Information*****************************************

const updateDeclarations = async () => {
  const token = sessionStorage.getItem("authToken");

  if (!refNumber.value && !token) {
    console.log("Customer Authentication Failed");
    return;
  } else {
    try {
      const response = await axios.post(
        "/updateDeclarations",
        {
          REFNUMBER: refNumber.value,
          PROMPERSON: radiopublicofficial.value,
          PROMRELATIVE: radiorelationship.value,
          NATOFREL: dropdownrelationshiptype.value,
          DETAILNAME: txtAssociateName.value,
          DETAILSURN: txtAssociateSurname.value,
          NOTINSOLVENT: check_NotInsolvent.value,
          UNDERSTOOD: check_readandunderstood.value,
          THIRDPARTY: radioThirdparty.value,
          SHAREGROUP: radioSharewithgroup.value,
          OTHERCOUNTRY: radioOthercountry.value,
        },
        {
          headers: {
            Authorization: token,
          },
        }
      );

      if (response.status !== 200) {
        isLoading.value = false;
        router.push("/TechnicalError");
        return;
      } else {
        // const respValue = response.data.RESPONSE.trim()

        if (response.data.RESPONSE !== " ") {
          if (dropdownIdentityType.value === "RSA ID") {
            checkExistingCard(); // Make sure this method is defined and accessible
          } else {
            console.log("No ID Type Selected!!! --- New APP");
            router.push("/NewApp");
          }
        }
      }
    } catch (error) {
      console.log(error);
      isLoading.value = false;
      router.push("/TechnicalError");
    }
  }
};

// ********************************************Function to Get Customer BPID****************************************************************

const GetBP = async () => {
  const token = sessionStorage.getItem("authToken");
  // Determine customer ID based on dropdownIdentityType
  custid.value =
    dropdownIdentityType.value === "Passport"
      ? txtPassportNumber.value
      : txtSaIdNumber.value;

  if (!refNumber.value && !token) {
    console.log("Customer Authentication Failed");
    return;
  } else {
    try {
      const response = await axios.post(
        "/GetBP",
        {
          getBP_Data: {
            CusID: custid.value,
          },
        },
        {
          headers: {
            Authorization: token,
          },
        }
      );

      if (response.status !== 200 || response.data.PartyId === "") {
        isLoading.value = false;
        console.log("Failed to Get Customer BPID Status")
        router.push("/TechnicalError");
      } else if (response.data.PartyId === "Not Found") {
        console.log("Customer BPID Not Found")
        // If BP ID not found, create a new one
        CreateBP(); // Ensure this function is defined or imported
      } else {
        // If BP ID exists
        partyId.value = response.data.PartyId;
        sessionStorage.setItem("partyid", response.data.PartyId); // Assuming session is handled with sessionStorage
        powercurveCall(); // Ensure this function is defined or imported
      }
    } catch (error) {
      console.log(error);
      isLoading.value = false;
      router.push("/TechnicalError");
    }
  }
};

// ********************************************Function to Find Customer BPID****************************************************************

const FindCustBP = async () => {
  const token = sessionStorage.getItem("authToken");
  // Determine customer ID based on dropdownIdentityType
  custid.value =
    dropdownIdentityType.value === "Passport"
      ? txtPassportNumber.value
      : txtSaIdNumber.value;

  if (!refNumber.value && !token) {
    console.log("Customer Authentication Failed");
    return;
  } else {
    try {
      const response = await axios.post(
        "/FindCustBP",
        {
          findCustomer_Data: {
            IssuedIdentType: "01",
            IssuedIdentValue: custid.value,
          },
        },
        {
          headers: {
            Authorization: token,
          },
        }
      );

      if (response.status !== 200 || response.data.PartyId === "") {
        isLoading.value = false;
        console.log("Failed to Find Customer BPID Status")
        router.push("/TechnicalError");
      } else if (response.data.PartyId === "Not Found" || response.data.PartyId === "" ) {
        console.log("Customer BPID Not Found")
        // If BP ID not found, create a new one
        CreateBP(); // Ensure this function is defined or imported
      } else {
        // If BP ID exists
        partyId.value = response.data.PartyId;
        sessionStorage.setItem("partyid", response.data.PartyId); // Assuming session is handled with sessionStorage
        powercurveCall(); // Ensure this function is defined or imported
      }
    } catch (error) {
      console.log(error);
      isLoading.value = false;
      router.push("/TechnicalError");
    }
  }
};

// ********************************************Function to Create Customer BPID*************************************************************
const CreateBP = async () => {
  const token = sessionStorage.getItem("authToken");
  let formattedDate = "";

  if (!refNumber.value && !token) {
    console.log("Customer Authentication Failed");
    return;
  } else {
    // Set gender and title
    if (radiosgender.value === "M") {
      gender.value = "1";
      title.value = "041";
    } else if (radiosgender.value === "F") {
      gender.value = "2";
      title.value = "042";
    }

    // Format date of birth
    dob.value = sessionStorage.getItem("DateofBirth");

    console.log(dob.value);

    if (dob.value) {
      formattedDate = `${dob.value.slice(0, 4)}-${dob.value.slice(
        4,
        6
      )}-${dob.value.slice(6, 8)}`;
    }
    console.log(formattedDate);

    // Set ID type and customer ID
    if (dropdownIdentityType.value === "Passport") {
      idtype.value = "06";
      custid.value = txtPassportNumber.value;
    } else {
      idtype.value = "01";
      custid.value = txtSaIdNumber.value;
    }

    // Set province code
    const provinceMapping = {
      GAUTENG: "ZAF.GP",
      LIMPOPO: "ZAF.LP",
      "FREE STATE": "ZAF.FS",
      "KWAZULU-NATAL": "ZAF.KZN",
      MPUMALANGA: "ZAF.MP",
      "NORTHERN CAPE": "ZAF.NC",
      "EASTERN CAPE": "ZAF.EC",
      "WESTERN CAPE": "ZAF.WC",
      "NORTH WEST": "ZAF.NW",
    };
    province.value = provinceMapping[province.value] || "ZAF.GP";

    try {
      const response = await axios.post(
        "/CreateBP",
        {
          cust_BPData: {
            PAAddr1: "None",
            PAAddr2: "None",
            PAAddr4: "None",
            PACity: "None",
            PAPostalCode: "0000",
            PAAddr3: "None",
            PAStateProv: province.value,
            PACountyDistrict: "MIDRAND",
            Phone: txtCellphone.value,
            EmailAddr: txtEmailaddress.value,
            IssuedIdentType: idtype.value,
            IssuedIdentValue: custid.value,
            Amt: txtTotalmonthlygrossincome.value,
            GivenName: txtFirstname.value,
            FamilyName: txtSurname.value,
            BirthDt: formattedDate,
            Gender: gender.value,
            NamePrefix: title.value,
          },
        },
        {
          headers: {
            Authorization: token,
          },
        }
      );

      if (response.status !== 200 || !response.data.PartyId) {
        isLoading.value = false;
        console.log("Failed to Create Customer BPID")
        router.push("/TechnicalError");
      } else {
        partyId.value = response.data.PartyId;
        sessionStorage.setItem("partyid", response.data.PartyId);
        powercurveCall(); // Ensure this function is defined or imported
      }
    } catch (error) {
      console.log(error);
      isLoading.value = false;
      router.push("/TechnicalError");
    }
  }
};

// ********************************************Function to Call Powercurve For  Scoring******************************************************
const powercurveCall = async () => {
  const token = sessionStorage.getItem("authToken");

  if (!refNumber.value && !token) {
    console.log("Customer Authentication Failed");
    isLoading.value = false;
  } else {
    const PCRef = refNumber.value.replace(/[^0-9]/g, "");
    const custidtype =
      dropdownIdentityType.value === "RSA ID" ? "FS0001" : "FS0002";

    const chagrgeoff =
      chargeoffDate.value === "" ? "19990101" : chargeoffDate.value;

    let prodcode;
    if (prodtype.value === "platinum") {
      prodcode = "ZDPC";
    } else if (prodtype.value === "shariah") {
      prodcode = "ZDSC";
    } else {
      prodcode = "ZDBC";
    }

    try {
      const response = await axios.post(
        "/powercurveCall",
        {
          cust_PCData: {
            FeGenAoRef: PCRef,
            FeGenCustNo: partyId.value,
            FeGenIdType: custidtype,
            FeGenIdNo: txtSaIdNumber.value,
            CpmCustTitle: "",
            CpmCustInitial: txtInitials.value,
            CpmCustFirstNam: txtFirstname.value,
            CpmCustSurNam: txtSurname.value,
            CpmCustDatOfBirth: sessionStorage.getItem("DateofBirth"),
            CpmCustGender: radiosgender.value,
            CpmCustTelCellNo: txtCellphone.value,
            CpmCustEmail: txtEmailaddress.value,
            CpmCustGrossmnthlyincme: txtTotalmonthlygrossincome.value,
            FeGenLoanPurpose: "",
            AppPGrossIncme: txtTotalmonthlygrossincome.value,
            AffPNetIncme: txtTotalmonthlynetincome.value,
            AffPTotIncme: txtTotalmonthlygrossincome.value,
            AffPTotMnthlyExpenses: txtTotalMonthlyExpenses.value,
            FeGenPrdCatgTyp: prodcode,
            FeGenReqLimRevdat: chagrgeoff,
            FeGenLockType: withdrawnCode.value,
            FeGenExesRevdat: withdrawnDate.value,
          },
        },
        {
          headers: {
            Authorization: token,
          },
        }
      );

      isLoading.value = false;

      if (response.status !== 200 || response.data.FinOffMaxLimAmnt === "") {
        isLoading.value = false;
        router.push("/TechnicalError");
      } else {
        const data = response.data;
        sessionStorage.setItem("grantedCreditLimit", data.FinOffMaxLimAmnt);
        sessionStorage.setItem("pcrefnumb", data.PcRefNumber);
        sessionStorage.setItem("fegenaoref", PCRef);
        sessionStorage.setItem("fegencustno", data.FeGenCustNo);
        sessionStorage.setItem("fintotmaxins", data.FinTotMaxInstall);
        sessionStorage.setItem("finprddecisioncod", data.FinProdDecisionCod);
        sessionStorage.setItem("finprddeclinecod1", data.FinProdDeclineCod1);
        sessionStorage.setItem("finprddeclinecod2", data.FinProdDeclineCod2);
        sessionStorage.setItem("custidtype", custidtype);
        sessionStorage.setItem("id", txtSaIdNumber.value);
        sessionStorage.setItem("initials", txtInitials.value);
        sessionStorage.setItem("firstname", txtFirstname.value);
        sessionStorage.setItem("surname", txtSurname.value);
        sessionStorage.setItem("gender", radiosgender.value);
        sessionStorage.setItem("contact", txtCellphone.value);
        sessionStorage.setItem("emailaddress", txtEmailaddress.value);
        sessionStorage.setItem("totgross", txtTotalmonthlygrossincome.value);
        sessionStorage.setItem("netincome", txtTotalmonthlynetincome.value);
        sessionStorage.setItem("totincome", txtTotalmonthlygrossincome.value);
        sessionStorage.setItem("expenses", txtTotalMonthlyExpenses.value);
        sessionStorage.setItem("prodcode", prodcode);

        creditGranted.value = response.data.FinOffMaxLimAmnt;
        powercurveData();

        isLoading.value = false;
        if (response.status === 200) {
          if (
            creditGranted.value <= 1000 ||
            response.data.FinProdDecisionCod !== "A"
          ) {
            // Route to DeclinedApp
            isLoading.value = false;
            router.push("/DeclinedApp");
            
          } else {
            // Route to ApprovedLimit
            isLoading.value = false;
            router.push("/ApprovedLimit");
          }
        } else {
          // Handle unexpected status codes
          console.error(`Unexpected response status: ${response.status}`);
          console.error(`Response data: ${JSON.stringify(response.data)}`);
          isLoading.value = false;

          // Route to DeclinedApp
          router.push("/TechnicalError");
        }
      }
    } catch (error) {
      if (error.response) {
        // The server responded with a status other than 2xx
        console.error(`API Error: ${error.response.status}`);
        console.error(`Response data: ${JSON.stringify(error.response.data)}`);

        // Handle different HTTP status codes
        switch (error.response.status) {
          case 400:
            console.error("Bad Request: Check the request data.");
            break;
          case 401:
            console.error("Unauthorized: Unauthorized User.");
            break;
          case 500:
            console.error("Server Error: Try again later.");
            break;
          default:
            console.error("An error occurred: ", error.response.status);
            break;
        }
        // Route to DeclinedApp
        isLoading.value = false;
        router.push("/TechnicalError");
      } else {
        console.log(error);
        // Route to DeclinedApp
        isLoading.value = false;
        router.push("/TechnicalError");
      }
    }
  }
};

// ********************************************Function to Store Powercurve Response******************************************************

const powercurveData = async () => {
  const token = sessionStorage.getItem("authToken");

  if (!refNumber.value && !token) {
    console.log("Customer Authentication Failed");
  } else {
    try {
      const response = await axios.post(
        "/powercurveData",
        {
          REFNUMBER: refNumber.value,
          PCREFNUMBER: sessionStorage.getItem("pcrefnumb"),
          FEGENAOREF: sessionStorage.getItem("fegenaoref"),
          FEGENCUSTNO: sessionStorage.getItem("partyid"),
          FINTOTMAXINS: sessionStorage.getItem("fintotmaxins"),
          FINMAXLIMIT: sessionStorage.getItem("grantedCreditLimit"),
          FINDECISION: sessionStorage.getItem("finprddecisioncod"),
          FINDECLCODE1: sessionStorage.getItem("finprddeclinecod1"),
          FINDECLCODE2: sessionStorage.getItem("finprddeclinecod2"),
          FRDDECISION: "",
          FRDDECLINE: "",
          DECLREASON: "",
        },
        {
          headers: {
            Authorization: token,
          },
        }
      );

      if (
        // response.status == 200
        response.data.data.RESPONSE === "UPDATED" ||
        response.data.data.RESPONSE === "ADDED"
      ) {
        console.log("Record has been stored");
      }
    } catch (error) {
      console.log(error);
      isLoading.value = false;
      router.push("/TechnicalError");
    }
  }
};

// %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%----Get Functions-----%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%

// Function to converts a YYYYMMDD string back to YYYY-MM-DD

const formatDateToDashed = (dateStr) => {
  if (!dateStr || dateStr.length !== 8) return "";
  const year = dateStr.slice(0, 4);
  const month = dateStr.slice(4, 6);
  const day = dateStr.slice(6, 8);
  return `${year}-${month}-${day}`;
};

const getPersonalInfor = async () => {
  const token = sessionStorage.getItem("authToken");

  if (!refNumber.value || !token) {
    console.log("User not authorized");
    isLoading.value = false;
    return;
  }

  try {
    const response = await axios.post(
      "/getPersonalInfor",
      {
        _REFNUMBER: refNumber.value,
      },
      {
        headers: {
          Authorization: token, // Auth token passed here
        },
      }
    );

    const data = response.data.data;

    txtCellphone.value = data._TELEPHONE;
    txtEmailaddress.value = data._EMAIL;
    dropdowntitle.value = data._TITLE;
    txtInitials.value = data._INITIALS;
    txtFirstname.value = data._FIRSTNAME;
    txtSurname.value = data._SURNAME;
    dropdownIdentityType.value = data._IDTYPE;

    if (data._IDTYPE === "Passport") {
      sessionStorage.setItem("IDType", data._IDTYPE);
      txtDOBPassport.value = formatDateToDashed(data._DATEOFBIRTH);
      txtPassportNumber.value = data._PASSPORT;
      txtPassExpDate.value = formatDateToDashed(data._PASSPORTEXP);

      getResidencyInfor();
    } else {
      txtbirthdate.value = formatDateToDashed(data._DATEOFBIRTH);
    }

    dropdownIssuingCountry.value = data._ISSCOUNTRY;
    txtSaIdNumber.value = data._IDNUMBER;
    txtPassportNumber.value = data._PASSPORT;
    radiosgender.value = data._GENDER;
    // dropdownnationality.value = data._NATIONALITY;
    dropdownCountryOfResidence.value = data._COUNTRYRES;
    dropdowncountryofcitizenship.value = data._COUNTRYCIT;
    dropdowncountryofbirth.value = data._COUNTRYBTH;
  } catch (error) {
    console.error("Error fetching personal information:", error);
  } finally {
    isLoading.value = false;
  }
};

const getResidencyInfor = async () => {
  const token = sessionStorage.getItem("authToken");

  if (!refNumber.value || !token) {
    console.log("Customer Authentication Failed");
    isLoading.value = false;
    return;
  }

  try {
    const response = await axios.post(
      "/getResidencyInfor",
      { _REFNUMBER: refNumber.value },
      {
        headers: {
          Authorization: token,
        },
      }
    );

    const data = response.data.data;

    if (data._VISATYPE === "") {
      // Optional logic if _VISATYPE is blank
      // e.g., dropdownvisapermittype.value = null;
    }

    dropdownvisapermittype.value = data._VISATYPE;
    txtPermitNumber.value = data._VISANUM;
    txtVisaIssueDate.value = formatDateToDashed(data._VISAISSUED);
    txtVisaExpDate.value = formatDateToDashed(data._VISAEXPIRES);
    radioforeignassets.value = data._FOREIGNASSET;
    radioemigration.value = data._PREVEMIGRATE;
    radiosimilarapp.value = data._SIMFACILITY;
  } catch (error) {
    console.error("Error fetching residency info:", error);
  } finally {
    isLoading.value = false;
  }
};

const getFinancialsInfor = async () => {
  const token = sessionStorage.getItem("authToken");

  if (!refNumber.value || !token) {
    console.log("Customer Authentication Failed");
    isLoading.value = false;
    return;
  }

  try {
    const response = await axios.post(
      "/getFinancialsInfor",
      { _REFNUMBER: refNumber.value },
      {
        headers: {
          Authorization: token,
        },
      }
    );

    txtTotalmonthlygrossincome.value = response.data.data._GROSSINCOME;
    txtTotalmonthlynetincome.value = response.data.data._NETTINCOME;
    txtTotalMonthlyExpenses.value = response.data.data._MONTHLYEXP;

    sessionStorage.setItem("grossIncome", response.data.data._GROSSINCOME);
  } catch (error) {
    console.error("Error fetching financial info:", error);
  } finally {
    isLoading.value = false;
  }
};

const getDeclarations = async () => {
  const token = sessionStorage.getItem("authToken");

  if (!refNumber.value || !token) {
    console.log("Customer Authentication Failed");
    isLoading.value = false;
    return;
  }

  try {
    const response = await axios.post(
      "/getDeclarations",
      { REFNUMBER: refNumber.value },
      {
        headers: {
          Authorization: token,
        },
      }
    );

    const data = response.data.data;

    radiopublicofficial.value = data.PROMPERSON;
    radiorelationship.value = data.PROMRELATIVE;
    dropdownrelationshiptype.value = data.NATOFREL;
    txtAssociateName.value = data.DETAILNAME;
    txtAssociateSurname.value = data.DETAILSURN;

    check_NotInsolvent.value = data.NOTINSOLVENT;
    check_readandunderstood.value = data.UNDERSTOOD;

    radioThirdparty.value = data.THIRDPARTY;
    radioSharewithgroup.value = data.SHAREGROUP;
    radioOthercountry.value = data.OTHERCOUNTRY;
  } catch (error) {
    console.error("Error fetching declarations:", error);
  } finally {
    isLoading.value = false;
  }
};
</script>

<style>
#border {
  padding: auto;
}

@font-face {
  font-family: "GathamBook";
  src: url("@/assets/fonts/Gotham-Book.woff2") format("woff2"),
    url("@/assets/fonts/Gotham-Book.otf") format("opentype");
  font-display: swap;
}

.NewApp-Toolbar {
  font-family: "GathamBook";
  /* font-size: 30px; */
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #fff;
  padding: 16px;
}

@font-face {
  font-family: "GathamMedium";
  src: url("@/assets/fonts/Gotham-Medium.woff2") format("woff2"),
    url("@/assets/fonts/Gotham-Medium.otf") format("opentype");
  font-display: swap;
}

.Personal-Information {
  font-family: "GathamMedium";
  font-size: 20px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #041e42;
}

.Affordability {
  font-family: "GathamMedium";
  font-size: 20px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #041e42;
}

.custom-prepend-icon {
  padding-right: 0px; /* Adjust the padding as needed */
}

.d-flex {
  display: flex;
  align-items: center;
}

.d-flex > span {
  margin-right: 10px; /* Adjust spacing as needed */
}

.v-radio-group {
  flex-direction: row; /* Ensure the group is horizontal */
}

.I-consent-to-Diners {
  font-weight: bold;
}
.custom-help-icon {
  color: #041e42; /* Background color of the circle */
}

.custom-help-icon path:nth-child(2) {
  fill: white; /* Color of the "?" */
}

.Declarations {
  font-family: "GathamMedium";
  font-size: 20px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #041e42;
}

@font-face {
  font-family: "GathamLight";
  src: url("@/assets/fonts/Gotham-Light.woff2") format("woff2"),
    url("@/assets/fonts/Gotham-Light.otf") format("opentype");
  font-display: swap;
}

.Contact-Information {
  font-family: "GathamLight";
  font-size: 28px;
  font-weight: 100;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #041e42;
}

.Total-Gross-Monthly {
  font-family: "GathamLight";
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #041e42;
}
.Prominent-Influentia {
  font-family: "GathamLight";
  font-size: 15px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #041e42;
}
.I-agree-and-confirm {
  font-family: "GathamLight";
  font-size: 15px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #041e42;
}

.I-consent-to-Diners {
  font-family: "GathamLight";
  font-size: 15px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #041e42;
}

p {
  font-family: "GathamLight";
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #041e42;
  text-align: left;
}
h1 {
  font-family: "GathamLight";
  color: #041e42;
}
h2 {
  font-family: "GathamLight";
  color: #041e42;
}
h3 {
  font-family: "GathamLight";
  color: #041e42;
}
.checkboxLabel {
  font-family: "GathamLight";
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #041e42;
  text-align: left;
}
</style>
